import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceARReceiveActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Voucher/VoucherBrowser")
	}

	render() {
		return (
			<Activity 
				menu="AR05"
				name="FinanceARReceive"
				RenderedComponent={this.RenderedComponent}
				context="FinanceARReceive"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceARReceiveActivity)
